
import { formRules } from "@/utils/formRules";
import { Component, Vue } from "vue-property-decorator";
import Telephone from "@/components/Telephone.vue";
import { activitySectors } from "@/utils/activitySectors";

@Component({
  components: {
    Telephone,
  },
})

export default class CreateCompany extends Vue {

  private master: any = {};
  private company: any = {};
  private formValidation: boolean = false;
  private rules: any = formRules;
  private loading: boolean = false;
  private clientCompanyId: number | null = null;
  private lockMasterEmailAndSiret: boolean = false;
  private activitySectorList: any[] = [];
  private legalCheckBox: boolean = false;

  public mounted() {
    // activitySectorList
    this.activitySectorList = activitySectors.map((activitySector) => (
      {key: activitySector, label: activitySector}
    ));
    this.activitySectorList.sort((a, b) => (a.label as any).localeCompare(b.label));

    // route query params (for non-admin creation only)
    if (this.$route.name === "create-company") {
      if (this.$route.query.email && this.$route.query.siret) {
        this.master.email = this.$route.query.email;
        this.company.siret = this.$route.query.siret;
        this.company.name = this.$route.query.name;
        this.company.activitySector = this.$route.query.activitySector;
        this.lockMasterEmailAndSiret = true;
        this.clientCompanyId = this.$route.query.clientCompanyId ? Number(this.$route.query.clientCompanyId) : null;
        this.$router.replace({ query: null });
      } else {
        this.$router.push({ name: "notFound" });
      }
      if (this.$route.query.activitySector) {
        this.activitySectorList.unshift({
          key: this.$route.query.activitySector,
          label: this.$route.query.activitySector,
        });
      }
    }
  }

  private async createCompany(): Promise<void> {
    this.loading = true;
    await this.$store.dispatch("public/companies/create", {
      company: this.company,
      master: this.master,
      clientCompanyId : this.clientCompanyId,
    }).then((data) => {
      this.$store.commit("alerts/displaySuccess", {
        msg: this.$i18n?.t("CreateCompany.creationSuccess"),
      });
      this.$router.push({ name: "home" });
    }).catch((error) => {
      this.$store.commit("alerts/displayHttpError", {error});
    }).finally(() => {
      this.loading = false;
    });
  }
}
